import { Button, Text, Stack, IconLock } from '@7shifts/sous-chef-base';
import { useAuth } from './AuthContext';
import { useTranslation } from '@src/i18n';
import { initiateLogin } from './authCodeFlow';
import './SessionExpiredPage.css';

export function SessionExpiredPage() {
    const { mode, clearAuth } = useAuth();
    const isWebview = mode === 'webview';
    const { t } = useTranslation();

    function handleSignIn() {
        clearAuth();
        void initiateLogin();
    }

    return (
        <main className="session-expired-page">
            <Stack space={20} alignItems="center">
                <div className="session-expired-page__icon-circle">
                    <IconLock size="large" />
                </div>
                <Stack space={8} alignItems="center">
                    <Text as="h1" alignment="center">
                        {t('sessionExpired.title')}
                    </Text>
                    <Text
                        as="h4"
                        alignment="center"
                        color="var(--color-surface-on-color-subtle)"
                    >
                        {isWebview
                            ? t('sessionExpired.messageWebview')
                            : t('sessionExpired.message')}
                    </Text>
                </Stack>
                {!isWebview && (
                    <Button
                        type="button"
                        theme="primary"
                        size="full-width"
                        onClick={handleSignIn}
                        testId="session-expired-sign-in"
                    >
                        {t('login.signIn')}
                    </Button>
                )}
            </Stack>
        </main>
    );
}
